import Hero from '../components/Hero';
import ProjectGrid from '../components/ProjectGrid';

const LandingPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center">
      <Hero />
      <ProjectGrid />
    </div>
  );
};

export default LandingPage;
